export enum UserTypes {
  admin = 'admin',
  Franchise = 'Franchise',
  Employee = 'Employee',
  Dealer = "Dealer",
  FranchiseSubUser = "FranchiseSubUser", 
  DealerSubUser = "DealerSubUser",
  Customer = "Customer",
  Manufacturer= "Manufacturer"
}